import * as dat from "dat.gui";
//创建gui对象
const gui = new dat.GUI();

export default gui;
